var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBiLightningCharge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bi:lightning-charge",
    clipPath: "url(#clip0_112_796)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.5339 0.178439C29.7908 0.327377 29.9896 0.559038 30.0979 0.835575C30.2061 1.11211 30.2173 1.41718 30.1298 1.70094L25.4022 17.0624H34.125C34.3814 17.0623 34.6321 17.1373 34.8464 17.2781C35.0606 17.4189 35.2289 17.6193 35.3305 17.8546C35.4321 18.09 35.4626 18.3499 35.4182 18.6024C35.3738 18.8549 35.2564 19.0888 35.0805 19.2753L14.0805 41.5878C13.8773 41.8039 13.607 41.9448 13.3134 41.9875C13.0199 42.0302 12.7206 41.9722 12.4642 41.8231C12.2079 41.6739 12.0096 41.4423 11.9018 41.166C11.7939 40.8897 11.7828 40.585 11.8703 40.3016L16.5979 24.9374H7.87504C7.61869 24.9375 7.36793 24.8626 7.1537 24.7218C6.93947 24.581 6.77116 24.3806 6.66954 24.1452C6.56792 23.9099 6.53745 23.6499 6.58187 23.3975C6.6263 23.145 6.74368 22.9111 6.91954 22.7246L27.9195 0.412064C28.1225 0.196287 28.3925 0.0555065 28.6856 0.0126138C28.9787 -0.0302788 29.2776 0.0272385 29.5339 0.175814V0.178439ZM10.9122 22.3124H18.375C18.5804 22.3124 18.783 22.3606 18.9664 22.4531C19.1498 22.5456 19.3089 22.6798 19.4309 22.845C19.553 23.0102 19.6346 23.2018 19.6691 23.4043C19.7036 23.6067 19.6902 23.8145 19.6298 24.0108L16.0388 35.6737L31.0853 19.6874H23.625C23.4196 19.6875 23.2171 19.6393 23.0337 19.5468C22.8503 19.4543 22.6912 19.3201 22.5691 19.1548C22.4471 18.9896 22.3655 18.7981 22.331 18.5956C22.2964 18.3931 22.3099 18.1854 22.3703 17.9891L25.9613 6.32619L10.9122 22.3124Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_112_796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiLightningCharge);
export default __webpack_public_path__ + "static/media/bi_lightning-charge.b0a3bdab43455c47c6d4f838e9b6fb23.svg";
export { ForwardRef as ReactComponent };